import { ThunkDispatch } from "redux-thunk";
import { connect } from "react-redux";

import { ApplicationState } from "../../../store/ApplicationState";
import { getNotesView } from "../../../actions/AuthorizationDetailsTab";
import { getPatientHeader } from "../../../actions/AllPatientRecords";
import PatientHeader from "../components";
import { AllPatientDispatchTypes } from "../../../models/DispatchTypes/AllPatientRecord";

const mapStateToProps = ({ patientHeaderState }: ApplicationState) => ({
  patientHeaderData: patientHeaderState,
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<ApplicationState, Record<string, never>, AllPatientDispatchTypes>
) => {
  return {
    getPatientHeader: (
      PatientId: number,
      referralId: number,
    ) => {
      dispatch(getPatientHeader(PatientId, referralId));
    },
    getNotesView: (referralNoteId: number) => {
      dispatch(getNotesView(referralNoteId));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PatientHeader);
